
import {
    select,
    fork,
    put,
    all,
    call,
    takeEvery,
  
  } from 'redux-saga/effects'
  import axios from 'axios'

  import {
    jwtConfig,
  } from 'helpers/RequestUtil'
  
  import {
    FETCH_FILE_FOR_THUMBNAIL
  } from './constants'

  import {
    addThumbnailLink,
    fetchFileForThumbnailStart,
    fetchFileForThumbnailSuccess,
    fetchFileForThumbnailError
  } from './actions'
  import { baseURL } from 'config'

  import { toBeFetchedThumbnailsSelector } from './selectors'

  function* fetchFileForThumbnail() {
    const imageFiles = yield select(toBeFetchedThumbnailsSelector)
      try {
        yield put(fetchFileForThumbnailStart())
        for (let { fileId, thumbnailId, name, fileType } of imageFiles) {    
          if (!thumbnailId) continue
          const { data } = yield call(
            axios.get,
          `${baseURL}/api/fulcrum/project/thumbnail_download/${thumbnailId}`,
            {
              ...jwtConfig(),
              responseType: 'blob'
            }
          )
          const localFileUrl = yield window.URL.createObjectURL(data)
          yield put(addThumbnailLink({fileId, thumbnailId, name, fileType}, localFileUrl))
        }
        yield put(fetchFileForThumbnailSuccess())
      } catch(error) {
        yield console.log(error)
        yield put(fetchFileForThumbnailError(error))
      }
  }

  function* handleFetchFileForThumbnail() {
    yield call(fetchFileForThumbnail)
  }

  function* watchFetchFileForThumnail(){
    yield takeEvery(FETCH_FILE_FOR_THUMBNAIL, handleFetchFileForThumbnail)
  }
  
  function* loadSagas() {
    yield all([
      fork(watchFetchFileForThumnail)
    ])
  }
  
  export default loadSagas
  